<template>

    <m-edit1/>

    <m-shopping-cart-3 v-bind='{...{"EmptyCartImage":null,"instagram":false,"presenterProp":false},...{}}' :style='""' class="my-5" ></m-shopping-cart-3>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mShoppingCart3 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/ShoppingCart3';

export default {
    name: 'HomeView',
    components: {mEdit1, mShoppingCart3 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
